import { useQuery } from '@apollo/client'
import { AppHeaderContext } from '@deltek/specification-client/core/Contexts/AppHeaderContext'
import { ListingDetail } from '@deltek/specification-client/core/Models/listing'
import { ContentLibrary } from '@deltek/specification-client/core/Models/product'
import { ProductListingHeader } from '@deltek/specification-client/core/Widgets/ProductListing/ProductListingHeader'
import { ProductListingDetailsQuery } from 'bpm/api/graphQL/queries/product.queries'
import React, { useContext, useMemo } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { ListingDetailsPage } from './components/ListingDetailsPage'

const ProductDetailsPage = () => {
    const { updateAppHeaderContent } = useContext(AppHeaderContext)
    const { listingId } = useParams<{ listingId?: string }>()
    const [productInfo, setProductInfo] = React.useState<
        Partial<ListingDetail> | undefined
    >(undefined)

    const { data, loading } = useQuery<{
        getListingDetail: Partial<ListingDetail>
    }>(ProductListingDetailsQuery, {
        variables: {
            listingIdInput: {
                listingId,
                logEventSource: 'BpmListingDetail',
            },
        },
        fetchPolicy: 'cache-and-network',
    })

    const history = useHistory()
    const queryParams = new URLSearchParams(history.location.search)

    const handleProductInfoUpdate = (value: Partial<ListingDetail>) => {
        setProductInfo(value)
    }
    const basePath = useMemo(() => {
        return history.location.pathname.split('/')?.[1]
    }, [history])

    const showBackButton = useMemo(() => {
        return (
            queryParams.get('showBackButton') ||
            queryParams.get('&showBackButton')
        )
    }, [queryParams])

    React.useEffect(() => {
        const comp = (
            <ProductListingHeader
                backButton={showBackButton === 'false' ? false : true}
                listingHeader="Manage Listing"
                urlLocation={`/${basePath}/products/all`}
            />
        )
        updateAppHeaderContent('', comp, false, true)
    }, [updateAppHeaderContent, history])

    React.useEffect(() => {
        if (!listingId) history.push('/bpm/products/all')
    }, [history, listingId])

    React.useEffect(() => {
        if (!loading && data?.getListingDetail && !productInfo) {
            setProductInfo({
                ...data.getListingDetail,
                assignedBPMUsers: data.getListingDetail.assignedBPMUsers ?? [],
                assignedDeltekUsers:
                    data.getListingDetail.assignedDeltekUsers ?? [],
                assignedContactUsers:
                    data.getListingDetail?.assignedContactUsers ?? [],
                bimLinks: data.getListingDetail.bimLinks ?? [],
                categories: data.getListingDetail.categories ?? [],
                manufacturerDocs: data.getListingDetail.manufacturerDocs ?? [],
                model: data.getListingDetail.model ?? '',
                productName: data.getListingDetail.productName ?? '',
                longDescription: data.getListingDetail.longDescription ?? '',
                contentLibrary:
                    ContentLibrary[
                        (data.getListingDetail.contentLibrary ??
                            'MasterSpec') as keyof typeof ContentLibrary
                    ],
            })
        }
    }, [loading, data, productInfo])

    return (
        <div className="product-listing-detail-container">
            {productInfo && (
                <ListingDetailsPage
                    firmId={data?.getListingDetail?.firmId}
                    productInfo={productInfo}
                    handleProductInfoUpdate={handleProductInfoUpdate}
                />
            )}
        </div>
    )
}

export default ProductDetailsPage
